module.exports = __webpack_public_path__ + "static/www/img/niao.a03ad44.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video/niao.jpg
// module id = 400
// module chunks = 1